<template>
  <v-container>
    <v-snackbar
      v-model="hasError"
      :top="true"
      :timeout="3000"
    >
      An error has occurred, please try again or contact us directly.
    </v-snackbar>
    <v-row align="center" justify="center">
      <v-col cols="12" md="5">
        <v-card class="pa-2 card-radius">
          <ValidationObserver ref="obs">
            <v-card-title class="py-1 my-1">
              <h4>Forgot your password?</h4>
            </v-card-title>
            <v-card-subtitle v-if="!sent" class="py-1 my-1">
              <p>Enter your email and we'll send you a link to get back into your account.</p>
            </v-card-subtitle>
            <v-card-text class="my-1 py-0">
              <v-container v-if="!sent" class="py-0 my-0">
                <v-row>
                  <v-col cols="12" class="my-1 py-0">
                    <ValidationProvider name="Email" rules="required|email" v-slot="{ errors, valid }">
                      <v-text-field
                        label="E-mail"
                        v-model="email"
                        :error-messages="errors"
                        :success="valid"
                        required
                      ></v-text-field>
                      <v-alert v-if="errors.length > 0 || hasError" type="warning" class="mt-2">Something isn't right. Please check your input and try again. Or  <a href="https://bit.ly/jeff_help" class="white--text">contact our support team.</a></v-alert>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-container>
              <v-alert v-if="sent" type="info">
                If a Web App account exists for {{email}}, an email has been sent with your password reset instructions.
              </v-alert>
            </v-card-text>
            <v-card-actions class="pt-0 mt-0">
              <v-spacer></v-spacer>
              <v-btn 
                color="secondary"
                :loading="saving"
                rounded 
                @click="save()">
                  SEND RESET INSTRUCTIONS
                </v-btn>
            </v-card-actions>
          </ValidationObserver>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { SEND_PASSWORD_RESET_MUTATION } from '../../constants/graphql/account/resetPassword'

  export default {
    name: 'RequestNewPassword',
    data() { return {
        email: '',
        saving: false,
        sent:  false,
        hasError: false,
        success: false
      }
    },
    methods: {
      save() {
        this.$apollo.mutate({
          mutation: SEND_PASSWORD_RESET_MUTATION,
          variables: {
            email: this.email,
          },
        }).then((response) => {
          if(response.data.sendPasswordResetEmail.success){
            this.sent = true
          } else {
            this.hasError = true;
          }
        }).catch((error) => {
          this.hasError = true;
        })
      },
    },
  }
</script>
